"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _context = require("../../actions/context");

var _constants = require("../../constants");

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _reducers = require("../../reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var useCompactLayoutChange = function useCompactLayoutChange() {
  _context.contextSetUnmappedView;

  var _useContext = (0, _react.useContext)(_AppContext.default),
      compactLayout = _useContext.compactLayout;

  var dispatch = (0, _reducers.useDispatch)();
  var reduxState = (0, _reducers.useStore)().getState();
  var viewingUnmapped = reduxState["".concat(_constants.PREFIX, ":context")].viewingUnmapped;
  (0, _react.useEffect)(function () {
    if (!compactLayout && viewingUnmapped) {
      dispatch((0, _context.contextSetUnmappedView)(false));
    } // disabling for viewingUnmapped, we only want to run when compactLayout changes
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [compactLayout, dispatch]);
};

var _default = useCompactLayoutChange;
exports.default = _default;